import { render, staticRenderFns } from "./expoExhibitor.vue?vue&type=template&id=628d4d21&scoped=true"
import script from "./expoExhibitor.vue?vue&type=script&lang=js"
export * from "./expoExhibitor.vue?vue&type=script&lang=js"
import style0 from "./expoExhibitor.vue?vue&type=style&index=0&id=628d4d21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d4d21",
  null
  
)

export default component.exports